import React, { useEffect, useState } from "react";
import { Input } from "antd";

import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { callApi, HttpMethod } from "../../../utils/httpRequest";
import { Stack } from "@mui/material";

const dolars = (amount) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 3,
  }).format(amount);

const input = {
  width: "117px",
  marginLeft: "4px",
  marginRight: "4px",
};

function Credits({ hcfId }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [credits, setCredits] = useState<any>(null);
  const [error, setError] = useState();

  useEffect(() => {
    callApi({
      method: HttpMethod.GET,
      url: `${global.api}/facilityprofile/credits`,
      query: {
        facilityId: hcfId,
      },
    })
      .then(setCredits)
      .catch(setError);
  }, [hcfId]);

  return (
    <Stack>
      <Title>Credit</Title>
      <ShowError error={error} message="Unable to fetch credit limit" />
      {credits && (
        <p className="content">
          Consumed <Input defaultValue={dolars(credits.consumed)} style={input} disabled /> Limit{" "}
          <Input defaultValue={dolars(credits.limit)} style={input} disabled />
        </p>
      )}
    </Stack>
  );
}

export { Credits };
